import moment from 'moment-timezone';
import { API_DATE_TIME_FORMAT } from '@ubeya/shared/constants';
import { getDurationFromMilliseconds } from '@ubeya/shared/utils/time';
import { mapStatus } from '@ubeya/shared-web/constants';

export const toMomentWithTz = (timestamp, timezone) => {
  if (!timestamp) return null;
  if (!timezone) return moment(timestamp, API_DATE_TIME_FORMAT);
  return moment.tz(timestamp, API_DATE_TIME_FORMAT, timezone);
};

// Latest break (highest id), or null when there are none — used to detect an open break.
export const getLatestBreak = (breaktimes = []) => {
  const latest = (breaktimes || []).reduce((prev, curr) => (curr.id > prev.id ? curr : prev), { id: -1 });
  return latest.id === -1 ? null : latest;
};

// Mirrors what each Live View column renders, as plain text, for excel export.
export const formatExportLiveView = ({ data, t, theme, timeFormat, mappedPositions, showCheckInOutColumns }) =>
  (data || []).map((row) => {
    const {
      firstName,
      lastName,
      statuses,
      actualIn,
      actualOut,
      actualCheckIn,
      actualCheckOut,
      totalBreakTimesCompleted,
      totalBreaksPlots,
      actualTotal,
      projectName,
      shiftLabel,
      positionId,
      isExternal,
      supplierData,
      comments,
      client,
      branch,
      shiftLocation,
      projectLocation,
      timezoneName
    } = row;

    const formatTime = (value) => (value ? moment(value).format(timeFormat) : '');

    const position = positionId ? mappedPositions[positionId]?.label : isExternal ? t(supplierData?.positionSlug) : '';

    return {
      [t('name')]: [firstName, lastName].filter(Boolean).join(' '),
      [t('dashboardTodayLiveViewStatus')]: (statuses || [])
        .map((status) => {
          const statusMetadata = mapStatus(status, theme);
          return statusMetadata && t(statusMetadata.slug);
        })
        .filter(Boolean)
        .join(', '),
      [t('in')]: formatTime(actualIn),
      [t('out')]: formatTime(actualOut),
      ...(showCheckInOutColumns
        ? {
            [t('checkInTime')]: formatTime(actualCheckIn),
            [t('checkOutTime')]: formatTime(actualCheckOut)
          }
        : {}),
      [t('breaks')]: `${totalBreakTimesCompleted}/${totalBreaksPlots}`,
      [t('totalTime')]: actualTotal > 0 ? getDurationFromMilliseconds(actualTotal) : '',
      [t('eventName')]: projectName,
      [t('shift')]: shiftLabel,
      [t('positions')]: [position, comments].filter(Boolean).join(', '),
      [t('client')]: client ?? '',
      [t('branch')]: branch?.name ?? '',
      [t('shiftArea')]: shiftLocation ?? '',
      [t('location')]: projectLocation ?? '',
      [t('timezone')]: timezoneName ?? ''
    };
  });
